import classNames from "classnames/bind";
import * as $ from "jquery";
import * as React from "react";
import { currentCultureSettings } from "../../../EasyProjectsCommon/setCulture";
import { WithEditModeViewerProps } from "../../../sharedHOC/withEditMode/withEditMode";
import { ComponentValidationProps } from "../../../sharedHOC/withValidation/withValidation";
import * as styles from "./DatePickerView.less";

const cx = classNames.bind(styles);

type DatePickerViewProps = WithEditModeViewerProps & ComponentValidationProps;

export const DatePickerView: React.FC<DatePickerViewProps> = ({ isFocused, invalid, value, showValidation }) => {
    const formatDate = value ? $.datepicker.formatDate(currentCultureSettings.dateFormat, value) : "mm/dd/yyyy";

    return (
        <div
            className={cx(styles.wrapper, {
                focused: isFocused,
                error: showValidation && invalid,
                empty: !value,
            })}
        >
            <span>{formatDate}</span>
        </div>
    );
};
